import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMinutes, setSeconds } from '../../redux/reducers/settingReducer';
import { FaPlus, FaMinus } from "react-icons/fa6";

const Timer = () => {
  const dispatch = useDispatch();
  const {
    quarter,
  } = useSelector((state) => state?.playersReducer);
  const { minutes, seconds, isRunning } = useSelector(
    (state) => state?.settingReducer
  );

  const [editMode, setEditMode] = useState({ type: null, value: '' });

  const handleMinutesChange = (amount) => {
    const newMinutes = minutes + amount;
    if (newMinutes >= 0) {
      dispatch(setMinutes(newMinutes));
    }
  };

  const handleSecondsChange = (amount) => {
    let newSeconds = seconds + amount;
    let newMinutes = minutes;

    if (newSeconds >= 60) {
      newMinutes += 1;
      newSeconds -= 60;
    } else if (newSeconds < 0) {
      if (newMinutes > 0) {
        newMinutes -= 1;
        newSeconds += 60;
      } else {
        newSeconds = 0; // Prevent negative seconds when minutes are zero
      }
    }

    dispatch(setMinutes(newMinutes));
    dispatch(setSeconds(newSeconds));
  };

  const handleEdit = (type) => {
    setEditMode({ type, value: type === 'minutes' ? minutes : seconds });
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) { // Ensure only digits are entered
      setEditMode({ ...editMode, value });
    }
  };

  const handleInputBlur = () => {
    const value = parseInt(editMode.value, 10);
    if (!isNaN(value) && value >= 0) {
      if (editMode.type === 'minutes') {
        dispatch(setMinutes(value));
      } else if (editMode.type === 'seconds') {
        dispatch(setSeconds(value < 60 ? value : 59));
      }
    }
    setEditMode({ type: null, value: '' });
  };

  const handleInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleInputBlur();
    }
  };

  return (
    <div className="flex justify-between items-center gap-1 lg:gap-[6px] max-w-[220px] w-full">
      <div className="flex flex-col lg:gap-4 gap-1">
        <button
          disabled={isRunning || quarter === "Final"}
          onClick={() => handleMinutesChange(1)}
          className="cursor-pointer w-5 lg:w-6 h-5 lg:h-6 rounded flex justify-center items-center"
          style={{
            boxShadow: "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >

          <FaPlus className='lg:text-base text-sm text-[#7D7D7D]' />
        </button>
        <button
          disabled={isRunning || quarter === "Final"}
          onClick={() => handleMinutesChange(-1)}
          className="cursor-pointer w-5 lg:w-6 h-5 lg:h-6 rounded flex justify-center items-center"
          style={{
            boxShadow: "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          <FaMinus className='lg:text-base text-sm text-[#7D7D7D]' />
        </button>
      </div>
      <div className="font-bebas text-[#1A1A1A] text-lg lg:text-2xl lg:text-[64px] flex items-center lg:gap-2 gap-1">
        {editMode.type === 'minutes' ? (
          <input
            type="text"
            value={editMode.value}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyPress={handleInputKeyPress}
            className="w-12 text-center"
            autoFocus
          />
        ) : (
          <span onClick={() => handleEdit('minutes')} className="cursor-pointer">
            {minutes}
          </span>
        )}
        :
        {editMode.type === 'seconds' ? (
          <input
            type="text"
            value={editMode.value}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyPress={handleInputKeyPress}
            className="w-12 text-center"
            autoFocus
          />
        ) : (
          <span onClick={() => handleEdit('seconds')} className="cursor-pointer">
            {seconds < 10 ? `0${seconds}` : seconds}
          </span>
        )}
      </div>
      <div className="flex flex-col lg:gap-4 gap-1">
        <button
          disabled={isRunning || quarter === "Final"}
          onClick={() => handleSecondsChange(1)}
          className="cursor-pointer w-5 lg:w-6 h-5 lg:h-6 rounded flex justify-center items-center"
          style={{
            boxShadow: "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          <FaPlus className='lg:text-base text-sm text-[#7D7D7D]' />
        </button>
        <button
          disabled={isRunning || quarter === "Final"}
          onClick={() => handleSecondsChange(-1)}
          className="cursor-pointer w-5 lg:w-6 h-5 lg:h-6 rounded flex justify-center items-center"
          style={{
            boxShadow: "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          <FaMinus className='lg:text-base text-sm text-[#7D7D7D]' />
        </button>
      </div>
    </div>
  );
};

export default Timer;
